import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getReverseGeocode} from '../../services/getReverseGeocode';

export function useGetReverseGeocodeQuery(latitude: string, longitude: string) {
	return useQuery({
		queryKey: [QUERY_KEYS.REVERSE_GEOCODE, latitude, longitude],
		queryFn: async ({signal}) => getReverseGeocode({latitude, longitude, signal}),
		enabled: false,
		retry: 2,
	});
}
